// extracted by mini-css-extract-plugin
export var compact = "_nh-2";
export var phoneFrame = "_nh-0";
export var phoneScreen = "_nh-1";